export const DECIMALS_WEI_USDC = 6

export const DECIMALS_WEI_ETH = 18

export const DEFAULT_FORMAT_NUMBER = 2

export const DEFAULT_DECIMAL = 4

export const DEFAULT_FORMAT_BALANCE = 6
